export const MS_PER_DAY = 86_400_000;

export const startOfUtcDay = (date: Date): Date =>
  new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
  );

export const diffInUtcDays = (later: Date, earlier: Date): number =>
  Math.round(
    (startOfUtcDay(later).getTime() - startOfUtcDay(earlier).getTime()) /
      MS_PER_DAY,
  );
